export default class AxiosError extends Error {
    constructor(axiosError) {
        // console.log('axiosError', axiosError);
        super(axiosError);

        this.message = axiosError.message;

        if (axiosError.response) {
            this.request = {};
            this.response = {
                status: axiosError.response.status,
                statusText: axiosError.response.statusText,
                headers: axiosError.response.headers,
                contentType: axiosError.response.headers['content-type'],
                contentLength: axiosError.response.headers['content-length'],
                data: axiosError.response.data
            };
        } else if (axiosError.request) {
            this.request = {
                method: axiosError.config.method,
                url: axiosError.config.url,
                headers: axiosError.config.headers
            };
            this.response = {};
        } else {
            this.request = {};
            this.response = {};
        }
    }
}



// WEBPACK FOOTER //
// ./src/Utils/AxiosError.js


// WEBPACK FOOTER //
// webpack:///src/Utils/AxiosError.js